import clsx from 'clsx';
import React, { FC } from 'react';
import { KTSVG } from '../../utils';
import { useLayout } from '../../layout/core';
import { IAuthState } from '../auth';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../../views/login/Login';
import { HeaderUserMenu } from './header-menus/HeaderUserMenu';
import { HeaderNotification } from './HeaderNotification';
import { HeaderSupport } from './HeaderSupport';

import './TopBar.scss';
import { useLocation } from 'react-router';
import { APPLICATION_VIEW_BASE_VIEW } from '../application-view/ApplicationViewAsideMenu';

export const TopBar: FC = () => {
	const { config } = useLayout();
	const { pathname } = useLocation();

	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const user = parseJwt(authUser.idToken);

	return (
		<div className="d-flex align-items-stretch flex-shrink-0">
			<div
				className={clsx('d-flex align-items-center ms-lg-3')}
				id="kt_header_user_menu_toggle"
			>
				{
					!pathname.includes(APPLICATION_VIEW_BASE_VIEW) && (
						<div className={clsx('d-flex align-items-center ms-lg-3')}>

							<HeaderSupport/>

							<HeaderNotification/>

						</div>
					)
				}
				<div
					className="cursor-pointer symbol d-none d-lg-block symbol-30px symbol-md-40px"
					data-kt-menu-trigger="click"
					data-kt-menu-attach="parent"
					data-kt-menu-placement="bottom-end"
					data-kt-menu-flip="bottom"
					data-cy="menu-icon"
				>
					<span
						className="font-weight-bold bg-light-danger rounded-2 d-flex align-items-center justify-content-center user-icon">
					{
						user ? (
							<>
								<span>{user?.given_name?.[0] || ''}</span>
								<span>{user?.family_name?.[0] || ''}</span>
							</>
						) : ''
					}
					</span>
				</div>
				<HeaderUserMenu/>
				{/* end::Toggle */}
			</div>
			{/* end::User */}

			{/* begin::Aside Toggler */}
			{config.header.left === 'menu' && (
				<div className="d-flex align-items-center d-lg-none ms-2 me-n3" title="Show header menu">
					<div
						className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
						id="kt_header_menu_mobile_toggle"
					>
						<KTSVG path="/media/icons/arrow-right.svg" className="svg-icon-1"/>
					</div>
				</div>
			)}
		</div>
	);
};

